module.exports = __webpack_public_path__ + "c_static/img/核对淘口令.c612072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/核对淘口令.jpg
// module id = 3oP8
// module chunks = 33